import "./msp-header.ui.scss";
import logoNuclias from "../../assets/img/v2/icon/logo_nuclias_cloud.png";
import iconUser from "../../assets/img/v2/icon/icon_user.png";
import iconLanguage from "../../assets/img/v2/icon/icon_language_normal.png";

import { Link, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import { useTranslation } from "react-i18next";
import useLangHook from "hooks/useLang";

// Component
import Icon from "components/Icon";
import DropdownWithItem from "components/DropdownWithItem";
import InputWithIconButton from "components/InputWithIconButton";
import LinkerWithA from "components/LinkerWithA";
import InputWithIcon from "components/InputWithIcon";

import { uiActions } from "stores/slice/ui";
import { loadOrgBootstarp } from "stores/slice/fetchStatus";

import { cloneDeep, isNil, size, truncate } from "lodash";

import mspHeaderService from "./service";
import headerService from "../Headers/service";
import { iconType, DEFAULT_TARGET_OBJ, userDropdownList, truncConfig } from "../Headers/const";
import { userType } from "const/nuclias/user";

const MSPHeader = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { langList, selectedLang, changeLang } = useLangHook();
  const { pageContext, user } = useSelector((store) => store);
  const userDetail = {
    title: user?.user?.name,
    icon: user?.user?.profilePhotoS3Path || iconUser,
  };
  const [rootOrg, setRootOrg] = useState({})
  const [search, setSearch] = useState({
    org: { name: "", total: 0 },
    site: "",
  });
  const [options, setOptions] = useState({ org: [], tag: [], site: [] });
  const [targetObj, setTargetObj] = useState({
    org: DEFAULT_TARGET_OBJ,
    site: DEFAULT_TARGET_OBJ,
  });

  const userDropdownClick = (item) => {
    if (item?.link) {
      navigate(item.link);
    } else if (item?.logout) {
      props.logout();
    }
  };

  const initOptions = () => {
    setOptions((options) => ({ ...options, tag: headerService.initTagOption() }));
    setOptions((options) => ({ ...options, site: headerService.initSiteOption() }));
  };

  const initTarget = () => {
    setTargetObj((targetObj) => ({ ...targetObj, org: mspHeaderService.initTargetOrg() }));
    setTargetObj((targetObj) => ({ ...targetObj, site: headerService.setTargetSite() }));
  };

  const searchOrg = async (value) => {
    dispatch(uiActions.showSpinner());
    let param = {
      search: search.org,
      data: options.org,
    };
    if (isNil(value)) {
      param.search = { name: "", total: 0 };
      param.data = [];
    } else {
      param.search = { name: value, total: 0 };
      param.data = [];
    }

    const res = await mspHeaderService.searchOrgOption(param); // search, data
    setSearch({ ...search, org: res.search });
    setOptions((options) => ({ ...options, org: res.data }));
    dispatch(uiActions.hideSpinner());
  };

  const getMoreOrg = async () => {
    dispatch(uiActions.showSpinner());
    let param = {
      search: search.org,
      data: options.org,
    };
    const res = await mspHeaderService.searchOrgOption(param); // search, data
    setSearch({ ...search, org: res.search });
    setOptions((options) => ({ ...options, org: res.data }));
    dispatch(uiActions.hideSpinner());
  };

  const initSearchOrg = (target) => {
    if (size(target.value) !== 0) {
      searchOrg(null);
      target.value = "";
    }
  };

  const loadOrg = (orgId) => {
    if (user?.user?.type === userType.si) {
      sessionStorage.setItem('mspSelectedOrg', orgId);
      sessionStorage.setItem('access_token', user.token.access_token);
    }
    dispatch(loadOrgBootstarp(orgId));
  };

  const loadMspOrg = () => {
    sessionStorage.removeItem('mspSelectedOrg');
    sessionStorage.removeItem('access_token');
    dispatch(loadOrgBootstarp(null));
  };

  const initSearchSite = (target) => {
    if (size(target.value) !== 0) {
      target.value = '';
      setSearch((search) => ({
        ...search,
        site: '',
      }));
    }
  };

  const changeSite = (item) => {
    headerService.changeSite(item);
    setTargetObj((targetObj) => ({ ...targetObj, site: headerService.setTargetSite() }));
  };

  const siteList = () => {
    let updatedList = options.site.filter((item) => {
      return item.name.toLowerCase().indexOf(search.site.toLowerCase()) !== -1;
    });
    let data = updatedList.map((item, index) => {
      return (
        <li key={`msp_header_site_dropdown_${index}`} className="search-site-item" onClick={() => { changeSite(item); }} >
          <i className={iconType.site}></i>{item.name}
        </li>
      );
    });
    if (size(data) > 0) {
      data.splice(0, 0, <hr key={`msp_header_site_dropdown_hr`} />);
    }
    return data;
  };

  const tagList = () => {
    let updatedList = options.tag.filter((item) => {
      return item.name.toLowerCase().indexOf(search.site.toLowerCase()) !== -1;
    });
    let data = updatedList.map((item, index) => {
      return (
        <li
          key={index}
          className="search-tag-item"
          onClick={(e) => {
            changeSite(item);
            e.stopPropagation();
          }}
        >
          <i className={iconType.tag}></i>
          {item.name}
        </li>
      );
    });
    return data;
  };

  const getSearchOrgLabel = () => {
    return `${t("3a6d32cc65", { "count": options.org?.length })} ${search.org?.total
      } ${t("cfb453439b")}.`;
  };

  useEffect(() => {
    if (!isNil(pageContext)) {
      setRootOrg(pageContext.si || pageContext.sp)
      initOptions();
      initTarget();
    }
  }, [pageContext]); //fetchStatus.reloadStatus.timestamp , props.headerDp

  return (
    <>
      <header className="menu-container menu-container--msp layout-container">
        <div className="left">
          <div className="icon icon-logo">
            <Link to="/">
              <img src={logoNuclias} alt="Nuclias" />
            </Link>
          </div>
          <div className="org-dropdown">
            <div className="dropdown">
              <button
                className="btn btn-dropdown dropdown-toggle"
                type="button"
                id="orgDropdown"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                onClick={() => searchOrg(null)}
                disabled={!props?.headerDp?.enableOrgDp}
              >
                <span>
                  <i className={targetObj?.org.icon}></i>
                  {truncate(targetObj?.org.name, truncConfig)}
                </span>
              </button>
              <ul className="dropdown-menu" aria-labelledby="orgDropdown">
                <InputWithIconButton
                  type="search"
                  placeholder="Search"
                  autoComplete="msp-search"
                  buttonClassName='icon-search-enter'
                  value={search?.org?.name}
                  onChange={(e) => {
                    const copy = cloneDeep(search);
                    copy.org.name = e.target.value;
                    setSearch(copy);
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      searchOrg(e.target.value);
                    }
                  }}
                  onFocus={() => console.log("Focus on icon button")}
                  onBlur={() => console.log("Blur on icon button")}
                  onClick={(e) => initSearchOrg(e.target)}
                  buttonOnClick={(e) => {
                    searchOrg(search.org.name);
                    e.stopPropagation();
                  }}
                />
                <div className="more-org">
                  <div className="show-more-info">{getSearchOrgLabel()}</div>
                  {/* {`${t('3a6d32cc65', {"@1":options.org?.length})} ${search.org?.total} ${t("12c99e21dd")}`}*/}
                  {options.org?.length > 0 &&
                    options.org?.length < search.org.total ? (
                    <LinkerWithA
                      label={t('2a725a2a3d')}
                      href="#"
                      className="linker-blue show-more text-decoration-underline"
                      onClick={(e) => {
                        getMoreOrg();
                        e.preventDefault();
                        e.stopPropagation();
                      }}
                    />
                  ) : null}
                </div>
                <li
                  className="search-msp-item"
                  onClick={() => {
                    loadMspOrg();
                  }}
                >
                  <i className="icon icon-msp"></i>
                  {rootOrg?.name}
                </li>
                {options.org &&
                  options.org.map((item, index) => {
                    return (
                      <li
                        key={index}
                        className="search-org-item"
                        onClick={() => {
                          loadOrg(item.id);
                        }}
                      >
                        <i className="icon icon-org"></i>
                        {item.name}
                      </li>
                    );
                  })}
              </ul>
            </div>
          </div>
          <div className="site-dropdown">
            <div className="dropdown">
              <button
                className="btn btn-dropdown dropdown-toggle"
                type="button"
                id="siteDropdown"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                disabled={
                  !pageContext.selectedOrg || !props?.headerDp?.enableSiteDp
                }
              >
                <span>
                  <i className={targetObj?.site.icon}></i>
                  {truncate(t(targetObj?.site.name), truncConfig)}
                </span>
              </button>
              <ul className="dropdown-menu" aria-labelledby="siteDropdown">
                <InputWithIcon
                  type="text"
                  iconPosition="left"
                  iconClassName="icon-search"
                  onChange={(e) => {
                    setSearch((search) => ({
                      ...search,
                      site: e.target.value,
                    }));
                  }}
                  onFocus={() => { }}
                  onBlur={() => { }}
                  onClick={(e) => initSearchSite(e.target)}
                  value={search.site}
                />
                <li
                  className="search-all-tag-item"
                  onClick={() => {
                    changeSite(null);
                  }}
                >
                  {t("b1c94ca2fb")}
                </li>
                {tagList()}
                {siteList()}
              </ul>
            </div>
          </div>
        </div>
        <div className="right">
          {
            props.alerts.announcement.show &&
            <>
              <div className="item">
                <Icon className="icon-announcement" />
                <span
                  className="number"
                  style={{
                    visibility: props.alerts.announcement.unread
                      ? "visible"
                      : "hidden",
                  }}
                >
                  !
                </span>
              </div>
              <div className="divided"></div>
            </>

          }

          {
            props.alerts.alert.show &&
            <>
              <div className="item">
                <Icon className="icon-alerts" />
                <span
                  className="number"
                  style={{
                    visibility: props.alerts.alert.unread ? "visible" : "hidden",
                  }}
                >
                  !
                </span>
              </div>
              <div className="divided"></div>
            </>
          }

          <div className="item">
            <div className="dropdown">
              <img
                src={userDetail.icon}
                className="icon btn-dropdown user"
                id="langDropdown"
                data-bs-toggle="dropdown"
                alt={userDetail.title}
              />
              <DropdownWithItem
                id="user-dropdown"
                extendClassName="btn-dropdown-no-border"
                selectedItem={userDetail}
                itemList={userDropdownList()}
                onClick={userDropdownClick}
              />
            </div>
          </div>
          <div className="divided"></div>
          <div className="item">
            <div className="dropdown normal">
              <img
                src={iconLanguage}
                className="icon btn-dropdown"
                id="langDropdown"
                data-bs-toggle="dropdown"
                alt={selectedLang[0].title}
              />
              <DropdownWithItem
                id="lang-dropdown"
                extendClassName="btn-dropdown-no-border"
                selectedItem={selectedLang[0]}
                itemList={langList}
                onClick={(item) => changeLang(item)}
              />
            </div>
            <div className="dropdown rwd">
              <DropdownWithItem
                id="lang-dropdown"
                type="icon"
                extendClassName="icon-language"
                selectedItem={selectedLang[0]}
                itemList={langList}
                onClick={(item) => changeLang(item)}
              />
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default MSPHeader;
